export default __webpack_public_path__ + "static/media/Logo.6bf3fb8b.svg";